<template>
    <div>
      <i class="fas fa-circle" v-if="params.value !== '0'" :class="pdrClass"></i>
      <span v-if="params.value !== 0">{{ pdrStatus }}</span>
    </div>
  </template>
<script>
export default {
  name: 'pdrStatusObraRenderer',
  computed: {
    pdrStatus () {
      return this.$lang.PCI.PDR.StatusObra['_' + (this.params.value || 0)]
    },
    pdrClass () {
      return {
        'initial': this.params.value === '0',
        'final-analises': this.params.value === '1',
        'analyzed': this.params.value === '2',
        'technical-director': this.params.value === '3',
        'administrative-director': this.params.value === '4',
        'finalized': this.params.value === '5',
        'paralyzed': this.params.value === '6',
        'rejected-tec-director': this.params.value === '-1',
        'na': this.params.value === '#NA#'
      }
    }
  }
}
</script>

<style scoped>
    .fas {
        font-size: 15px;
        text-shadow: -1px 1px 2px black;
    }
    .initial {color: burlywood;}
    .final-analises { color: darkviolet; }
    .analyzed { color: magenta; }
    .technical-director { color: gray; }
    .administrative-director { color: blue; }
    .finalized { color: green; }
    .paralyzed { color: black; }
    .rejected, .rejected-tec-director { color: red; }
    .na { color: white; }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/PdrStatusObraRenderer.vue